import React from 'react';
import './breadcrumb.css';
import { Link } from 'react-router-dom';

function Breadcrumb({ items }) {
  return (
    <div className="page-title">
      <h1>{items[items.length - 1].label}</h1>
      <nav>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">
              <i className="bi bi-house-door"></i>
            </Link>
          </li>
          {items.map((item, index) =>
            item.href ? (
              <li key={index} className="breadcrumb-item">
                <Link to={item.href}>{item.label}</Link>
              </li>
            ) : (
              <li key={index} className="breadcrumb-item active">
                {item.label}
              </li>
            )
          )}
        </ol>
      </nav>
    </div>
  );
}

export default Breadcrumb;
